import React from 'react';

const AboutHeader = ({ title }) => {
  return (
    <>
    <section
          className='page-header position-relative overflow-hidden ptb-120 bg-dark'
        >
          <div className='container'>
            <div>
              <div className='col-lg-8 col-md-12'>
                <h1 style={{color:'#fff'}} className='display-5 fw-bold'>{title}</h1>
              </div>
            </div>
          </div>
        </section>
    </>
  );
};

export default AboutHeader;
